import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import backendApiService from "../service/backend-api.service";

const noop = async () => {};

const AccountContext = createContext({
  account: null,
  loading: false,
  refresh: noop,
  setAccount: () => {},
  logout: noop,
});

export function AccountProvider({ children }) {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setAccount(await backendApiService.getAccount());
    } catch {
      setAccount(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await backendApiService.logout();
    } finally {
      setAccount(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({ account, loading, refresh, setAccount, logout }),
    [account, loading, refresh, logout],
  );

  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>;
}

/** Вне провайдера (тесты отдельных форм) — как без входа. */
export function useAccount() {
  return useContext(AccountContext);
}
